export default "__VITE_ASSET__B3xG1$H0__"